module.exports = __webpack_public_path__ + "img/responsive crc-03.2d5b09be.jpg";